import React from 'react';
import BankImportPage from './BankImportPage';

export default function BunqPage() {
  return (
    <BankImportPage
      title="BUNQ Import"
      description="Import BUNQ transactions using the standard CSV export (Date, Interest Date, Amount, Account, Counterparty, Name, Description)."
      fieldLabels={['Date', 'Interest Date', 'Amount', 'Account', 'Counterparty', 'Name', 'Description']}
      listEndpoint="/api/bunq"
      importEndpoint="/api/bunq/import"
      bankId="BUNQ"
      emptyText="No BUNQ records found."
    />
  );
}
